export const NAME = 'CONSULTATION';

export const getConsultationSlots = (store) => store[NAME].slots || [];
